module.exports = __webpack_public_path__ + "img/lucia.31326893.png";